import { render, staticRenderFns } from "./userOrderDetail.vue?vue&type=template&id=4d24a24c&scoped=true&"
import script from "./userOrderDetail.vue?vue&type=script&lang=js&"
export * from "./userOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./userOrderDetail.vue?vue&type=style&index=0&id=4d24a24c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d24a24c",
  null
  
)

export default component.exports